<template>
    <div v-if="serialList.length>0" class="bg-fff shadow margin-top-20 padding-bottom-20">
        <header class="base-title font-bold">
            {{$t("erp.productSerialNos.index",{ defaultValue: "产品序列号"})}}
        </header>
        <Table class="margin-10"
            :columns="serialcolumns"
            :data="serialList"
            size="small"
            ref="table"
            border
            stripe>
        </Table>
    </div>
</template>

<script>
    import { HttpSerialNoList } from '@/service/boss/allot';
    export default {
        props:['orderid'],
        data(){
            return {
                serialList:[]
            }
        },
        created(){
            HttpSerialNoList({
                'search[EQ_saleOrderId]':this.orderid
            }).then(res=>{
                this.serialList = res.data.content
                console.log(res,'234234')
            })
        },
        computed:{
            serialcolumns(){
                return [
                    {
                        title: 'Seller SKu',
                        key: 'sellerSku',
                        render(h, { row }) {
                            return <div>{row.sellerSku}</div>
                        }
                    }, {
                        title: this.$t('erp.serialNos.index',{defaultValue:'序列号'}),
                        key: 'serialNo',
                        render(h, { row }) {
                            return <div>
                            {row.serialNo}
                            </div>
                        }
                    }, 
                    {
                        title: this.$t('erp.takeup.time',{defaultValue:'占用时间'}),
                        key: 'updatedAt',
                        render(h, { row }) {
                            return <div>
                            {row.updatedAt}
                            </div>
                        }
                    }, 
                    
                ]
            }
        },
        
    }
</script>
